/* eslint-disable operator-linebreak */
import { Dispatch } from 'redux';
import { INotification } from 'src/interfaces';
import notificationsService from 'src/services/notifications.service';
import { NotificationsActionType } from '../action-types';
import { NotificationsAction } from '../actions';

export const getNotifications = () => async (dispatch: Dispatch<NotificationsAction>) => {
  dispatch({
    type: NotificationsActionType.GET_NOTIFICATIONS,
  });

  try {
    const { data }: { data: INotification[] } = await notificationsService.getNotifications();

    dispatch({
      type: NotificationsActionType.GET_NOTIFICATIONS_SUCCESS,
      payload: { notifications: data },
    });
  } catch (err: any) {
    dispatch({
      type: NotificationsActionType.GET_NOTIFICATIONS_FAILURE,
      payload: err.message,
    });
  }
};
